export const FormLabel: any = {
  baseStyle: {
    mb: '0',
    fontSize: 'xs',
    letterSpacing: '0.48px',
    opacity: 0.8,
    fontWeight: '300',
  },
}
